import { Observable, Observer } from 'rxjs';
import { NgZone } from '@angular/core';

export namespace ZoneObservable {
  export function create<T>(zone: NgZone, fn: (observer: Observer<T>) => void): Observable<T> {
    return new Observable((observer: Observer<T>) => {
      const proxyObserver: Observer<T> = {
        next: (value: T) => {
          zone.run(() => observer.next(value));
        },
        error: (err: any) => {
          zone.run(() => observer.error(err));
        },
        complete: () => {
          zone.run(() => observer.complete());
        }
      };

      fn(proxyObserver);
    });
  }

  export function of<T>(zone: NgZone, value: T): Observable<T> {
    return new Observable((observer: Observer<T>) => {
      zone.run(() => {
        observer.next(value);
        observer.complete();
      });
    });
  }
}
